// extracted by mini-css-extract-plugin
export default {"cls1":"e1DfiWVmNJlmfvCU3XUC","cls2":"FLcoeZg5FNr1gdkmLFah e1DfiWVmNJlmfvCU3XUC"};